<template>
 <table class="styled-table">
    <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">{{ $t("fuelType") }}</th>
       <th scope="col">{{ $t("fuelConsumption") }} <strong>(t)</strong></th>
     </tr>
  </thead>
  <tbody>
    <tr v-for="(fuel, index) in indexedArrayFuel" :key="index">
     <td>
      {{ fuel.displayIndex }}
     </td>
     <td>
        {{ fuel.fuel.name }}
     </td>
     <td>
        {{ fuel.consumption}}
     </td>
    </tr>
  </tbody>

 </table>
</template>

<script>

export default{

    created(){
        
        this.arrayFuel = this.fuelArray
    },

    data(){
     return{
        arrayFuel : [],
     }
    },

    computed: {
      indexedArrayFuel() {
        return this.arrayFuel.map((fuel, index) => {
          return {
            ...fuel,
            displayIndex: index + 1
          };
        });
      }
    },

    props:{
        fuelArray : Array
    }, 
}

</script>

<style scoped>

.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

</style>